//TODO MOBA II - this seems to only be used in PS.
//     Upd 03 2018: Has been removed from PS, but usages could be found in LYFLE. See OnClickFormSubmitterRemoval2018
(function (Lfl, $, undefined) {

    (function (Forms, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Forms, 'OnClickFormSubmitter')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * This object allows for registering elements that can perform a post HTTP request when clicked.
         *
         * Those elements are de-facto submit buttons.
         *
         * @memberOf Lfl.Forms
         */
        Lfl.Forms.OnClickFormSubmitter;

        (function (OnClickFormSubmitter, $, undefined) {
            /*
             |===========================================================================================================
             | Object definition
             |===========================================================================================================
             */

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /**
             * Registers a button which will submit the form along with a input that distinguishes the said button.
             * @memberOf Lfl.Forms.OnClickFormSubmitter
             *
             * @param {jQuery} $button The button.
             * @param {Object} theForm The form which the button should submit. Not a jQuery object!
             * @param {string} inputName Can be the same for all buttons that submit the said form.
             * @param {string} inputValue Should be unique for each submitting button.
             */
            OnClickFormSubmitter.registerNamedSubmitButton = function(
                $button,
                theForm,
                inputName,
                inputValue
            ) {
                $button.click(
                    function() {
                        Lfl.Forms.Inputs.addHidden(theForm, inputName, inputValue);
                        theForm.submit();
                    }
                );
            };

            /**
             * Submits the form closest to the target element.
             * @memberOf Lfl.Forms.OnClickFormSubmitter
             */
            OnClickFormSubmitter.performClosestFormSubmit = function ($target) {
                // Note: Forms::PreventMultipleSubmits - the element itself should be disabled by adding the new
                // multi-submit prevention attribute, so no event should be fired that would trigger this method.
                // In case any issues arise (this method allowing multi-submit) make sure that the events are prevented.
                $target.closest('form').trigger('submit');
            };

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */
        }(Forms.OnClickFormSubmitter = Forms.OnClickFormSubmitter || {}, jQuery));
    }(Lfl.Forms = Lfl.Forms || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));